import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Config from '../config';
import { toHref, getParam, isLogin, getPUBK, accestokenByCode, getUserInfo, deleteToken, } from '../utils';
class Auth {
    data = {
        authUrl: '',
        mode: '',
        authLoginType: '',
        pathname: window.location.pathname,
        onFinish: (url) => { },
    };
    isNoLogin() {
        return getParam('code') && !isLogin();
    }
    async init(params) {
        window.sessionStorage.removeItem('noclose');
        this.data.authUrl = params.path;
        this.data.mode = params.mode || '';
        this.data.authLoginType = params.authLoginType || '';
        if (params?.onFinish) {
            this.data.onFinish = params.onFinish;
        }
        const userInfo = await this.initUserInfo(params);
        return userInfo;
    }
    logout(e, s, msg, userId) {
        window.sessionStorage.setItem('noclose', 'noclose');
        this.deleteToken(e, s, msg, userId);
    }
    async getVisitorId() {
        const fpPromise = FingerprintJS.load();
        const fp = await fpPromise;
        const result = await fp.get();
        const { deviceMemory, ...components } = result.components;
        const visitorId = FingerprintJS.hashComponents(components);
        localStorage.setItem('fp', visitorId);
        return visitorId;
    }
    async initUserInfo(params) {
        if (!localStorage.getItem('fp')) {
            await this.getVisitorId();
            const userInfo = await this.authlogin(params);
            return userInfo;
        }
        else {
            return await this.authlogin(params);
        }
    }
    async getAccessUser(accessToken) {
        sessionStorage.setItem('ACCESS_TOKEN', accessToken);
        // 解析token获取用户信息
        return toHref(accessToken);
    }
    async getUserInfoFormCode(params) {
        const code = getParam('code');
        const basicSecret = await getPUBK(params.mode, params.authLoginType);
        return await accestokenByCode(params, code, basicSecret);
    }
    replaceUrl() {
        let url = window.location.href;
        const state = getParam('state');
        if (url.indexOf('?') != -1) {
            //判断是否存在参数
            url = url.replace(/(\?|#)[^'"]*/, ''); //去除参数
        }
        if (state && this.data.onFinish) {
            this.data.onFinish(decodeURIComponent(state));
        }
        else {
            window.history.pushState(null, '', url);
        }
    }
    async authlogin(params) {
        let isRepalceUrl = false;
        return new Promise((resolve, reject) => {
            /**
             * 登录和白名单
             */
            if (isLogin() ||
                (params.allow && params.allow.includes(this.data.pathname))) {
                resolve(getUserInfo());
                return;
            }
            /**
             * 有accessToken
             */
            const accessToken = getParam('access_token') || getParam('ACCESS_TOKEN');
            if (accessToken) {
                resolve(this.getAccessUser(accessToken));
                return;
            }
            /**
             * 没有登录
             */
            if (this.isNoLogin()) {
                isRepalceUrl = true;
                resolve(this.getUserInfoFormCode(params));
                return;
            }
            /**
             * 退出登录
             */
            if (getParam('logout') === 'yes') {
                this.deleteToken();
                resolve(undefined);
                return;
            }
            /**
             * 其他情况
             */
            if (Config.grant_type === 'authorization_code') {
                resolve(undefined);
                let urlHost = '';
                urlHost = params.urlHref || Config.baseUrl;
                const state = params.search
                    ? `&state=${encodeURIComponent(params.search)}`
                    : '';
                window.location.href =
                    params.path +
                        '/oauth/authorize?response_type=code&client_id=' +
                        Config.appId +
                        '&redirect_uri=' +
                        urlHost +
                        state;
                return;
            }
        }).finally(() => {
            if (isRepalceUrl) {
                this.replaceUrl();
            }
        });
    }
    // msg 0 或者不传是发消息登出，其他值不发消息，-99 修改密码所有端登出
    deleteToken(e, s, msg, uId) {
        deleteToken(this.data.authUrl, e, s, msg, uId);
    }
}
// 新版本引入方式
export const auth = new Auth();
// 兼容老版本引入方式
export const Thing = () => {
    console.log('new Thing()');
    return auth;
};
